import writeXlsxFile from 'write-excel-file/browser'
import { ColumnDefinition, ExportMetadata } from './exportToCsv'

// Excel refuses a sheet name with any of these characters, or longer than 31.
const ILLEGAL_IN_SHEET_NAME = /[[\]/\\:*?]/g

/**
 * Export table data to Excel (.xlsx) file
 * Uses the same column definitions and metadata as CSV export
 */
export async function exportToExcel(
  data: any[],
  columns: ColumnDefinition[],
  metadata: ExportMetadata
): Promise<void> {
  if (!data || data.length === 0) {
    console.warn('No data to export')
    return
  }

  // Transform data using column definitions (same logic as CSV)
  const rows = data.map((row) =>
    columns.map((col) => {
      const value = row[col.key]
      return col.format ? col.format(value, row) : value
    })
  )

  // Auto-size columns based on header and content width. Excel measures
  // width in characters plus 5px of padding; xlsx wrote that as +213/256.
  const widths = columns.map((col, i) => {
    const maxDataLen = rows.reduce((max, row) => {
      const val = row[i]
      return Math.max(max, val != null ? String(val).length : 0)
    }, 0)
    return { width: Math.min(Math.max(col.label.length, maxDataLen) + 2, 40) + 213 / 256 }
  })

  const sheet = metadata.title.replace(ILLEGAL_IN_SHEET_NAME, '_').substring(0, 31) || 'Sheet1'

  // Generate filename
  const timestamp = new Date().toISOString().split('T')[0]
  const sanitizedTitle = metadata.title.replace(/[^a-zA-Z0-9æøåÆØÅ]/g, '_')
  const filename = `${sanitizedTitle}_${timestamp}.xlsx`

  // Trigger download
  await writeXlsxFile([columns.map((col) => col.label), ...rows], { sheet, columns: widths }).toFile(
    filename
  )
}
